"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
let url = '';
const init = (webhookURL) => {
    url = webhookURL;
};
/**
 * Post a message to slack
 * @param {object} data
 * @example postToSlack({channel:'@user',text:'hello'})
 */
const postToSlack = ({ text }) => {
    const data = {
        text: text
    };
    return axios_1.default(url, {
        data: data,
        // required for sending msg by frontend
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST'
    });
};
exports.default = {
    init,
    postToSlack
};
//# sourceMappingURL=SlackService.js.map